export interface UppKonvaCanvasPixelTarget {
  setPixelRatio(ratio: number): unknown;
}

export interface UppKonvaLayerPixelRatioTarget {
  getCanvas(): UppKonvaCanvasPixelTarget;
  getHitCanvas(): UppKonvaCanvasPixelTarget;
}

/**
 * Caps sharpness for the layer's scene and hit canvases.
 * (Konva Core `Stage` does not expose `pixelRatio()`; tuning lives on each `Layer`'s canvases.)
 */
export function applyLayerPixelRatioCap(
  layer: UppKonvaLayerPixelRatioTarget,
  pixelRatioMax: number,
  devicePixelRatio: number,
): void {
  const dpr = Number.isFinite(devicePixelRatio) && devicePixelRatio > 0 ? devicePixelRatio : 1;
  const cap = Number.isFinite(pixelRatioMax) && pixelRatioMax > 0 ? pixelRatioMax : 2;
  const ratio = Math.min(dpr, cap);
  layer.getCanvas().setPixelRatio(ratio);
  layer.getHitCanvas().setPixelRatio(ratio);
}
